import { ClientReducerState } from 'client/reducers';
import { selectStorySettings } from '../reducers/story/selectors';

export function getRestrictionsParams(state: ClientReducerState) {
	const settings = selectStorySettings(state);
	const isOncePerUser = settings?.restrictions?.oncePerUser;
	const integrationUrlParams = settings?.integrations?.urlParams;
	const gameIds = Object.entries(integrationUrlParams?.gameIds ?? {})
		.filter(([key, value]) => value && integrationUrlParams?.params?.includes(key))
		.map(([key]) => key);

	if (isOncePerUser && gameIds?.length) {
		const urlParams = new URLSearchParams(window.location.search);
		const result: Record<string, string> = {};

		urlParams.forEach((value, key) => {
			if (gameIds.includes(key)) result[key] = value;
		});

		if (Object.keys(result).length) {
			return result;
		}
	}

	return null;
}
